import { useState } from "react"
import { useNavigate } from "react-router-dom"

import supabase from "../../utils/subabaseClient"

export default function useData() {
  const [username, setUsername] = useState("")
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const handleSubmit = async (event) => {
    event.preventDefault()
    setLoading(true)
    try {
      const { data, error } = await supabase.auth.signUp({
        email,
        password,
        options: { data: { username } },
      })
      if (error) {
        console.error("Error registering user:", error.message)
      } else {
        await supabase
          .from("symfonia_users")
          .insert({ username, email, auth_user_id: data?.user?.id })
        console.log("User registered successfully!")
        navigate("/login")
      }
    } catch (error) {
      console.error("Error registering user:")
    }
    setLoading(false)
  }

  return {
    username,
    setUsername,
    email,
    setEmail,
    password,
    setPassword,
    handleSubmit,
    loading,
  }
}
